export { default } from './ChooseAdditionalWorkshop';

